//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import upload from './upload.vue';
export default {
  data: function data() {
    return {
      visible: false,
      activeName: '1'
    };
  },
  components: {
    upload: upload
  },
  methods: {
    init: function init() {
      this.visible = true;
    } // doSubmit() {
    //   this.visible = false
    //   this.$emit('submit')
    // }
  }
};